import React, { Component } from "react";
export class Pagination extends Component {
  render() {
    const {
      postsPerPage,
      totalPosts,
      paginate,
      nextPage,
      prevPage,
      current,
    } = this.props;

    const pageNumbers = [];

    for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i++) {
      pageNumbers.push(i);
    }

    return (
      <nav>
        <ul className="pagination justify-content-center">
          <li className="page-item">
            <span
              className="text-dark cursor page-link"
              onClick={() => prevPage()}
            >
              Previous
            </span>
          </li>
          {pageNumbers.map((num) => (
            <li className="page-item" key={num}>
              <span
                onClick={() => paginate(num)}
                className={
                  num && current === num
                    ? " cursor page-link text-white bg-red"
                    : "text-dark cursor page-link"
                }
              >
                {num}
              </span>
            </li>
          ))}
          <li className="page-item">
            <span
              className="text-dark cursor page-link"
              onClick={() => nextPage()}
            >
              Next
            </span>
          </li>
        </ul>
      </nav>
    );
  }
}

export default Pagination;
